import { createFileRoute } from '@tanstack/react-router';
import { MisExperiencias } from '../../features/experiences/components/misExperiencias';

/**
 * `/mis-experiencias` (P-14, ADR-0018: rutas del navegador en kebab-case). Bajo `_autenticado`
 * (exige sesión, `routes/_autenticado.tsx`) — pero, a diferencia de `_autenticado/centro.tsx`,
 * SIN guarda de rol propia: esta pantalla es para cualquiera con cuenta, no solo `ADMIN`/
 * `COLLABORATOR`. `GET /me/experiences` (`useMisExperiencias`) ya filtra por el `userId` de
 * quien pregunta, así que no hay ningún rol ni tier que comprobar antes de dejar pasar.
 */
export const Route = createFileRoute('/_autenticado/mis-experiencias')({ component: MisExperiencias });
